var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnyxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 687.48 463.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #1077ba;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eslogan"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.34,447.44l-14.09-44.15h4.63l11.87,37.99h-1.4l11.74-37.99h3.49l11.81,37.99h-1.46l11.87-37.99h4.7l-14.16,44.15h-3.43l-11.74-37.93h1.33l-11.74,37.93h-3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.55,447.44l17.9-44.15h3.49l17.71,44.15h-5.01l-15.43-39.02h1.84l-15.55,39.02h-4.95ZM88.74,435.96v-4.17h22.85v4.17h-22.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.43,407.59v-4.3h35.42v4.3h-35.42ZM136.8,447.44v-42.93h4.7v42.93h-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.6,447.44v-44.15h4.63v44.15h-4.63ZM171.65,407.59v-4.3h25.33v4.3h-25.33ZM171.65,426.91v-4.17h23.68v4.17h-23.68ZM171.65,447.44v-4.3h25.71v4.3h-25.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.8,447.44v-44.15h4.63v44.15h-4.63ZM212.78,427.68v-3.98h12.7c2.88,0,5.08-.74,6.6-2.21,1.52-1.48,2.29-3.46,2.29-5.94s-.76-4.35-2.29-5.87-3.72-2.28-6.6-2.28h-12.7v-4.11h12.7c2.83,0,5.27.52,7.3,1.57,2.03,1.05,3.59,2.49,4.67,4.33,1.08,1.84,1.62,3.94,1.62,6.29s-.54,4.58-1.62,6.42-2.63,3.26-4.67,4.27c-2.03,1.01-4.47,1.51-7.3,1.51h-12.7ZM236.2,447.44l-16.38-20.41,4.51-1.48,17.84,21.88h-5.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.99,407.59v-4.3h35.42v4.3h-35.42ZM282.35,447.44v-42.93h4.7v42.93h-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314.15,447.44v-44.15h4.63v44.15h-4.63ZM317.14,427.68v-3.98h12.7c2.88,0,5.08-.74,6.6-2.21,1.52-1.48,2.29-3.46,2.29-5.94s-.76-4.35-2.29-5.87-3.72-2.28-6.6-2.28h-12.7v-4.11h12.7c2.83,0,5.27.52,7.3,1.57,2.03,1.05,3.59,2.49,4.67,4.33,1.08,1.84,1.62,3.94,1.62,6.29s-.54,4.58-1.62,6.42-2.63,3.26-4.67,4.27c-2.03,1.01-4.47,1.51-7.3,1.51h-12.7ZM340.56,447.44l-16.38-20.41,4.51-1.48,17.84,21.88h-5.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M357.26,447.44v-44.15h4.63v44.15h-4.63ZM360.3,407.59v-4.3h25.33v4.3h-25.33ZM360.3,426.91v-4.17h23.68v4.17h-23.68ZM360.3,447.44v-4.3h25.71v4.3h-25.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.22,447.44l17.9-44.15h3.49l17.71,44.15h-5.02l-15.42-39.02h1.84l-15.55,39.02h-4.95ZM403.41,435.96v-4.17h22.85v4.17h-22.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M436.1,407.59v-4.3h35.42v4.3h-35.42ZM451.46,447.44v-42.93h4.7v42.93h-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M483.26,447.44v-44.15h3.3l18.85,31.25h-2.35l18.85-31.25h3.3v44.15h-4.7v-35.94l1.08.26-15.74,26.12h-3.3l-15.74-26.12,1.08-.26v35.94h-4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M540.14,447.44v-44.15h4.63v44.15h-4.63ZM543.19,407.59v-4.3h25.33v4.3h-25.33ZM543.19,426.91v-4.17h23.68v4.17h-23.68ZM543.19,447.44v-4.3h25.71v4.3h-25.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M581.34,447.44v-44.15h3.3l1.33,5.58v38.57h-4.63ZM611.55,447.44l-27.61-37.86.7-6.29,27.55,37.86-.63,6.29ZM611.55,447.44l-1.4-5.33v-38.83h4.7v44.15h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M626.53,407.59v-4.3h35.42v4.3h-35.42ZM641.89,447.44v-42.93h4.7v42.93h-4.7Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Letras"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.41,357.49c-12.31,0-23.48-2.36-33.5-7.09-10.02-4.73-18.64-11.15-25.86-19.26-7.23-8.11-12.81-17.25-16.75-27.42s-5.91-20.6-5.91-31.32,2.05-21.86,6.16-32.03c4.1-10.16,9.89-19.22,17.36-27.18,7.47-7.96,16.21-14.26,26.23-18.91,10.01-4.65,20.85-6.97,32.51-6.97,12.31,0,23.48,2.44,33.5,7.33,10.01,4.89,18.6,11.43,25.74,19.62,7.14,8.2,12.68,17.34,16.63,27.42,3.94,10.09,5.91,20.41,5.91,30.96,0,11.19-2.05,21.86-6.16,32.03-4.11,10.16-9.85,19.23-17.24,27.18-7.39,7.96-16.09,14.22-26.11,18.79-10.02,4.57-20.85,6.85-32.51,6.85ZM36.63,272.4c0,9.14,1.56,17.93,4.68,26.35,3.12,8.43,7.55,15.92,13.3,22.46,5.75,6.54,12.6,11.74,20.57,15.6,7.96,3.86,16.71,5.79,26.23,5.79,10.01,0,19-2.01,26.97-6.03,7.96-4.02,14.78-9.37,20.44-16.07,5.67-6.7,9.98-14.22,12.93-22.57,2.96-8.35,4.43-16.86,4.43-25.53,0-9.14-1.56-17.88-4.68-26.24-3.12-8.35-7.6-15.84-13.42-22.46-5.83-6.62-12.68-11.82-20.57-15.6-7.88-3.78-16.59-5.67-26.11-5.67s-18.76,1.97-26.72,5.91c-7.97,3.94-14.78,9.26-20.44,15.96-5.66,6.7-10.02,14.22-13.05,22.57-3.04,8.35-4.56,16.86-4.56,25.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.7,219.81v133.85h-14.98v-163.57h12.41l99.73,136.38v-136.15h14.98v163.34h-13.91l-98.23-133.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M402.61,190.45l45.54,84.7,45.97-84.7h20.76l-57.2,103.24v59.29h-19.07v-59.75l-56.98-102.78h20.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M642.96,352.07l-42.65-67.3-42.65,67.3h-20.13l52.81-82.41-51.22-80.12h20.13l41.05,65.01,41.05-65.01h20.33l-51.22,80.12,52.81,82.41h-20.33Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Gota"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.26,108.89c0,27.67-22.43,50.1-50.1,50.1s-50.1-22.43-50.1-50.1,41.15-76.25,50.1-97.84c6.07,17.92,50.1,70.17,50.1,97.84Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnyxLogo);
export default __webpack_public_path__ + "static/media/onyx-logo.316da85243c4f0fc7519ef5fb3caee49.svg";
export { ForwardRef as ReactComponent };